import { WithContentNavigator, withContentNavigator } from "../../../hocs/ContentNavigator/withContentNavigator";
import { WithAnalytics, withAnalytics } from "../../../hocs/withAnalytics";
import { WithActions, withActions } from "../../../hocs/withActions";
import React, { CSSProperties, PropsWithChildren } from "react";
import { BaseComponentProps } from "../../../../common/types/Data/BaseComponentProps";
import { PagePost } from "../../../../common/Facebook/PagePost";
import { ModulePreview } from "../Common/ModulePreview";
import { ModulePreviewHeader } from "../Common/ModulePreviewHeader";
import { ModulePreviewImage } from "../Common/ModulePreviewImage";

export type Props = BaseComponentProps<PagePost> & {};

const buildBackgroundStyle = (pagePost: PagePost): CSSProperties => {
    return {
        backgroundImage: `url(${pagePost.full_picture})`,
        backgroundSize: "cover",
    };
};

const FacebookGalleryBaseModuleDecorated = (props: PropsWithChildren<Props & WithActions & WithAnalytics & WithContentNavigator>) => {
    const {
        entity,
        contentNavigator,
        analyticsUtils: { trackClickModuleEvent },
        nested,
    } = props;

    const onClick = () => {
        trackClickModuleEvent(entity);
        contentNavigator.open("facebook:gallery", { entity }, { nested });
    };

    const style = buildBackgroundStyle(entity.linkedContent);

    return (
        <ModulePreview classNames={["GalleryImage"]} onClick={onClick}>
            <ModulePreviewHeader className={"gallery"} label={entity.shortLabel || entity.label} />
            <ModulePreviewImage entity={entity} file={undefined} style={style} noConditional={true} />
        </ModulePreview>
    );
};

export const FacebookGalleryBaseModule = withContentNavigator(withAnalytics(withActions(FacebookGalleryBaseModuleDecorated)));
